import { isPublicTokenPagePath } from '@repo/utils';

/**
 * Pagine pubbliche col token nel path: documento del rapportino (`/d/wr/…`)
 * e firma del contratto (`/contract/…`). Elenco unico in `@repo/utils`
 * (`PUBLIC_TOKEN_PAGE_PATHS`), lo stesso che il backend usa per redigere i
 * log.
 */
export function isPublicDocumentPath(pathname: string): boolean {
  return isPublicTokenPagePath(pathname);
}

/**
 * Su una pagina pubblica col token nel path l'indirizzo è la chiave del
 * documento: non deve uscire come `Referer` (né verso il nostro backend, che
 * lo registrerebbe nei log, né verso altri siti) né finire nelle registrazioni
 * di sessione. Da chiamare al boot, prima del router e delle prime richieste.
 * Restituisce `true` se la pagina è una di queste: il chiamante salta gli
 * strumenti di analisi (Clarity, replay di Sentry) e i provider dell'app
 * autenticata.
 */
export function protectPublicDocumentPage(
  location: Pick<Location, 'pathname'> = window.location,
  doc: Document = document
): boolean {
  if (!isPublicDocumentPath(location.pathname)) return false;
  const meta = doc.createElement('meta');
  meta.name = 'referrer';
  meta.content = 'no-referrer';
  doc.head.prepend(meta);
  const robots = doc.createElement('meta');
  robots.name = 'robots';
  robots.content = 'noindex, nofollow';
  doc.head.append(robots);
  return true;
}
